import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import axios from 'axios';
import { getApiUrl, API_ENDPOINTS, STORAGE_KEYS } from '../../config/apiConfig';
import './AdminLogin.css';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: 'admin@ppm.com',
    password: 'Admin@123'
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        getApiUrl(API_ENDPOINTS.ADMIN.LOGIN),
        formData
      );

      // Store admin token and user info
      localStorage.setItem(STORAGE_KEYS.ADMIN_TOKEN, response.data.token);
      localStorage.setItem(STORAGE_KEYS.ADMIN_USER, JSON.stringify(response.data.admin));

      toast.success('Admin login successful!');
      navigate('/admin/dashboard');
    } catch (error) {
      console.error('Admin login error:', error);
      toast.error(error.response?.data?.error || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <h1>Admin Portal</h1>
          <p>Sign in to access the admin dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="form-group">
            <label htmlFor="email">
             <i className="fas fa-envelope" style={{ "margin-right": "2%" }}></i> Email Address
              </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="admin@ppm.com"
              autoComplete="email"
            />
          </div>
{/* 
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              required
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </div> */}

          <div className="form-group">
            <label htmlFor="password" className="form-label custom-label">
              <i className="fas fa-lock" style={{ "margin-right": "2%" }}></i>
              Password
            </label>
            <div className="password-container">

              <input
                id="password"
                type={showPassword ? "text" : "password"}
                required
                value={formData.password}
                onChange={handleChange}
                className="form-input"
                placeholder="Enter your password"
              />
              <i
                className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                onClick={() => setShowPassword(!showPassword)}
              />
            </div>
          </div>

          <button
            type="submit"
            className="admin-login-btn"
            disabled={loading}
          >
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <div className="admin-login-footer">
          <p>
            <Link to="/" className="back-link">← Back to main site</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;


